import menu from './menu';
import notifications from './notifications';

const pathname = window.location.pathname.replace(/^\//, '').replace(/\/$/, '');
let connection = window.env.CONNECTION || '';

const connections = [
    { id: 'filter-pro', name: 'Filter Pro', link: '/admin/filter-pro' },
    { id: 'nz-parts', name: 'NZ Parts', link: '/admin/nz-parts' },
    { id: 'truck-parts', name: 'Truck Parts', link: '/admin/truck-parts' },
];
window.env.connections = connections;
window.env.apiPrefix = connection;

export default {
    rootPath: window.env.APP_URL,
    apiPrefix: connection ? `api/${connection}` : 'api',
    currentConnection: connection,
    connections: connections,
    cmsTitle: window.env.APP_NAME,
    cmsPath: '/admin',
    routes: {
        default: '/dashboard',
        endpoints: {
            '^/pages': {
                params: { filter: 'parent_id:$null' },
            },
            '^/panels': {
                params: { filter: 'content_id:$null' },
            },
            '^/categories': {
                params: { filter: 'parent_id:$null' },
            },
            '^/customers': {
                params: { sort: 'name:asc' }
            },
            '^/customer_logins': {
                params: { sort: 'registered_at:desc' }
            },
            '^/enquiries': {
                params: { sort: 'enquiry_date:desc' }
            },
            '^/products': {
                params: { sort: 'name:asc;partno:asc', append: 'category_list,make_model_count' }
            },
            '^/lookup': {
                params: { sort: 'name:asc' }
            },
            '^/make_models': {
                params: { sort: 'model:asc' }
            },  
            '^/orders': {
                params: { sort: 'order_date:desc' }
            },
            '^/order/[\\d]+$': {
                params: { include: 'items,customer,customer_login' }
            },
            '^/order/[\\d]+/status$': {
                params: { sort: 'created_at:desc' }
            },
            '^/category_groups': {
                params: { sort: 'name:asc' }
            },
            '^/product_groups': {
                params: { sort: 'parent_id:asc;name:asc', filter: 'parent_id$id:$null' }
            },
        }
    },
    file: {
        extensions: {
            img: ['png', 'jpg', 'jpeg', 'gif', 'svg'],
            doc: ['doc', 'docx'],
            pdf: ['pdf'],
            xls: ['xls', 'xlsx'],
            csv: ['csv'],
        }
    },
    menu,
    notifications,
    inboxActive: false,
}
